import React from 'react';
import PropTypes from 'prop-types';
import stateMapper from '@/src/models/stateMapper';
import WebScripts from '@/src/scripts';
import View from '@/src/views/resetPassword';
import { SessionService, TrackingService } from '@/src/server/services';
import { getAppVersion, getPlatform, getLocale } from '@/src/server/utils';

export default function ResetPassword({ trackerConfig }) {
  return (
    <>
      <WebScripts trackerConfig={trackerConfig} />
      <View />
    </>
  );
}

ResetPassword.propTypes = {
  trackerConfig: PropTypes.shape({
    historicalEnabled: PropTypes.bool,
    gtmConfig: PropTypes.object,
    commonData: PropTypes.object,
  }),
};

const getMessages = async (locale = 'es') => {
  const response = await import(`../../translations/${locale}.js`);
  return response ? response.default : {};
};

export async function getServerSideProps({ req, query }) {
  const { token, ...queryParams } = query;
  // From Session
  const country = SessionService.getCountry(req) || {};
  const user = SessionService.getUser(req);
  const headersPedidosYa = SessionService.getPedidosYaHeaders(req);
  // From Request
  const currentVersion = getAppVersion(req);
  const currentPlatform = getPlatform(req);

  const locale = getLocale(country);
  const messages = await getMessages(locale);

  const initialState = stateMapper({
    appVersion: currentVersion,
    platform: currentPlatform,
    user,
    country,
    searchQueryParams: queryParams,
  });

  const trackerConfig = TrackingService.getTrackerConfig(req);

  return {
    props: {
      initialState,
      trackerConfig,
      i18n: {
        messages,
        locale,
      },
      axios: {
        headers: headersPedidosYa,
      },
    },
  };
}
